import {StyledBox, StyledChatMessageBox, StyledImg, StyledPaper, StyledStack} from '../ChatViewStyles'
import BouncingLoader from '../BouncingLoader'
import CustomChipIndex from '../../../../../Common/CustomChip/CustomChipIndex'
import PropTypes from 'prop-types'
import MarkdownRenderer from '../../../../../Common/MarkdownRenderer/MarkdownRendererIndex'

const ChatMessages = ({responseData, loader}) => {
  return (
    <StyledChatMessageBox>
      {responseData.length > 0 && (
        <StyledStack spacing={1}>
          {responseData.map((item, index) => {
            const hasText = !!item.data?.text
            const hasInterestTags = item.data?.interestTagId?.length > 0
            if (!hasText && !hasInterestTags) return null
            return (
              <StyledBox key={`${item.data?.text}-${index}`} sender={item.sender}>
                <StyledPaper elevation={1} sender={item.sender}>
                  {hasText && (
                    <div style={{display: 'flex'}}>
                      {item.sender === 'bot' && <StyledImg src="/llm-star.svg" alt="Ask_Giveprism_Image" />}
                      <MarkdownRenderer sender={item?.sender} markdownText={item.data?.text?.replaceAll('```', '')} />
                    </div>
                  )}
                  {hasInterestTags && (
                    <div>
                      <CustomChipIndex chipData={item.data?.interestTags} />
                    </div>
                  )}
                </StyledPaper>
              </StyledBox>
            )
          })}
        </StyledStack>
      )}
      {loader && <BouncingLoader />}
    </StyledChatMessageBox>
  )
}

ChatMessages.propTypes = {
  responseData: PropTypes.array.isRequired,
  loader: PropTypes.bool.isRequired
}

export default ChatMessages
